import { deleteItem } from '../util/delete-item';

export const deleteAnswer = event => {
  const $target = event.currentTarget;
  const $answer = $target.closest('.js-quizAnswer');
  deleteItem(event, $answer, 'answer');
};
